import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { RoundRepository } from "../../core/round/round.repository";

@Injectable()
export class StopAutoplayUseCase implements IUseCase<number, void> {
    constructor(private roundRepository: RoundRepository) {
    }

    execute(betIndex: number): void {
        return this.roundRepository.stopAutoplay(betIndex);
    }
}
